import { Close } from "@carbon/icons-react";
import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useOrderContext } from "../../../contexts/OrderContext";
import { IStep } from "../../../models/step";
import "./ProgressBarPopup.scss";
import StepItem from "./StepItem";

interface ProgressBarPopupProps {
  isOpen: boolean;
  progressLevel: number;
  handleClose: () => void;
  onJumpTo: (setProgressLevelTo: number) => void;
}

const ProgressBarPopup = (props: ProgressBarPopupProps) => {
  const { t } = useTranslation();
  const { steps } = useOrderContext();
  const { isOpen, progressLevel, handleClose, onJumpTo } = props;

  const clickItem = (step: IStep) => {
    handleClose();
    if (step.done) onJumpTo(step.number);
  };

  const renderedSteps = steps.map((step) => {
    const isSelected = step.number === progressLevel;
    let menuItemClass = "progress-bar-popup-item";
    if (isSelected) menuItemClass += " progress-bar-popup-item-selected";
    if (step.done && !isSelected) {
      menuItemClass += " progress-bar-popup-item-done";
    }

    return (
      <StepItem
        key={step.number}
        step={step}
        isSelected={isSelected}
        menuItemClass={menuItemClass}
        clickItem={clickItem}
      />
    );
  });

  return (
    <Dialog
      id="progress-bar-popup"
      open={isOpen}
      onClose={handleClose}
      PaperProps={{ className: "progress-bar-popup" }}
    >
      <div
        data-testid="progress-bar-popup"
        className="progress-bar-popup-header"
      >
        <div className="progress-bar-popup-header-text">
          {t("createDelivery")}
        </div>
        <Close onClick={handleClose} size={24} />
      </div>
      {renderedSteps}
    </Dialog>
  );
};

export default ProgressBarPopup;
